// src/components/ProtectedRoute.jsx

import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../config/AuthProvider';

function ProtectedRoute({ children }) {
  const { currentUser, isAdmin } = useContext(AuthContext);

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/not-authorized" replace />; // Kreirajte ovu stranicu
  }

  return children;
}

export default ProtectedRoute;
